import { apiFetch, apiDownload } from "./client";
import type { ApiResponse } from "@/types/api";

export interface Nit {
  nit: string;
  razon_social: string;
  dv?: string;
  ciudad?: string;
  telefono?: string;
  direccion?: string;
  correo_electronico?: string;
  pais?: string;
  created_at?: string;
  updated_at?: string;
}

export interface NitPagination {
  total: number;
  page: number;
  limit: number;
  total_pages: number;
}

export interface CreateNitRequest {
  nit: string;
  razon_social: string;
  dv?: string;
  ciudad?: string;
  telefono?: string;
  direccion?: string;
  correo_electronico?: string;
  pais?: string;
}

export interface UpdateNitRequest {
  razon_social?: string;
  nit?: string;
  dv?: string;
  ciudad?: string;
  telefono?: string;
  direccion?: string;
  correo_electronico?: string;
  pais?: string;
}

export interface BulkImportResponse {
  status: "success";
  msg: string;
  count: number;
}

export const listNits = (params: { page?: number; limit?: number; q?: string } = {}) =>
  apiFetch<ApiResponse<Nit[]>>("/api/v1/nits", {
    params: {
      page: params.page ?? 1,
      limit: params.limit ?? 50,
      q: params.q ?? "",
    },
  }).then((res) => ({
    data: res.data ?? [],
    pagination: (res as unknown as { pagination?: NitPagination }).pagination,
  }));

export const getNit = (nit: string) =>
  apiFetch<ApiResponse<Nit>>(`/api/v1/nits/${encodeURIComponent(nit)}`).then(
    (res) => res.data as Nit,
  );

export const createNit = (body: CreateNitRequest) =>
  apiFetch<ApiResponse<null>>("/api/v1/nits", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const updateNit = (nit: string, body: UpdateNitRequest) =>
  apiFetch<ApiResponse<null>>(`/api/v1/nits/${encodeURIComponent(nit)}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const deleteNit = (nit: string) =>
  apiFetch<ApiResponse<null>>(`/api/v1/nits/${encodeURIComponent(nit)}`, {
    method: "DELETE",
  });

export const bulkImportNits = (file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiFetch<BulkImportResponse>("/api/v1/nits/bulk", {
    method: "POST",
    body: formData,
  });
};

export const downloadNitTemplate = () =>
  apiDownload("/api/v1/nits/template", undefined, "plantilla_nits.xlsx");
